import TtamPromotionFlowType from './promotion-flow-type/index.vue';
import * as hooks from './hooks';
export default {
  TtamPromotionFlowType,
  ...hooks,
};
